module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.project.owner) ? _c('div', [(_vm.project.status === 'created') ? _c('div', [_c('checkbox', {
    model: {
      value: (_vm.domoreConsent),
      callback: function($$v) {
        _vm.domoreConsent = $$v
      },
      expression: "domoreConsent"
    }
  }, [_c('b', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v(_vm._s(_vm.$t('project.verification.acceptRules')))])]), _vm._v(" "), _c('checkbox', {
    model: {
      value: (_vm.mangopayConsent),
      callback: function($$v) {
        _vm.mangopayConsent = $$v
      },
      expression: "mangopayConsent"
    }
  }, [_c('b', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v(_vm._s(_vm.$t('project.verification.acceptMangopayRules')))])])], 1) : _vm._e(), _vm._v(" "), (_vm.project.status === 'created') ? _c('button', {
    class: 'btn btn-default btn-lg button-wide-' + _vm.crowd_or_rais,
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.verifyProject
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.processing),
      expression: "!processing"
    }]
  }, [_vm._v(_vm._s(_vm.$t("project.verification.verifyBtn")))]), _vm._v(" "), _c('clip-loader', {
    attrs: {
      "loading": _vm.processing,
      "color": '#fff',
      "size": "17px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.project.status === 'pending') ? _c('button', {
    staticClass: "btn btn-default btn-lg mt-20 btn-wide crowdfunding disabled",
    attrs: {
      "type": "button"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.processing),
      expression: "!processing"
    }]
  }, [_vm._v(_vm._s(_vm.$t("project.verification.verifying")))]), _vm._v(" "), _c('clip-loader', {
    attrs: {
      "loading": _vm.processing,
      "color": '#fff',
      "size": "17px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.project.status === 'approved') ? _c('button', {
    class: 'btn btn-default btn-lg mt-20 button-wide-' + _vm.crowd_or_rais,
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.publishProject
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.processing),
      expression: "!processing"
    }]
  }, [_vm._v(_vm._s(_vm.$t("project.verification.publish")))]), _vm._v(" "), _c('clip-loader', {
    attrs: {
      "loading": _vm.processing,
      "color": '#fff',
      "size": "17px"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('alert', {
    staticClass: "mt-20 mb-0",
    attrs: {
      "success": _vm.verificationInfo,
      "error": _vm.verificationError
    }
  }), _vm._v(" "), _c('light-kyc', {
    ref: "lightKyc",
    on: {
      "fetch:user": _vm.setUser
    }
  }), _vm._v(" "), (_vm.user.mangopay_id || _vm.project.submitted) ? _c('regular-kyc', {
    attrs: {
      "documentId": _vm.user.kyc_document_id
    },
    on: {
      "submitted": _vm.setKycIds
    }
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d5d4743a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Project/Verification.vue
// module id = 837
// module chunks = 1